module.exports = __webpack_public_path__ + "static/media/user-circle.d9553155.svg";